/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerExportJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Export Jobs
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 16, 2019 - 01:51:12 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      12/16/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    EXPORTJOB_LIST_CONTAINER_LOADED,
    EXPORTJOB_LIST_CONTAINER_UNLOADED,
    EXPORTJOB_LIST_TABLE_LOADED,
    EXPORTJOB_LIST_TABLE_UNLOADED,

    EXPORTJOB_SELECT_ROW,
    EXPORTJOB_UPDATE_VALUE,
    EXPORTJOB_ADD,
    EXPORTJOB_EDIT,
    EXPORTJOB_DELETE,
    EXPORTJOB_OPEN_WARNING,
    EXPORTJOB_CLOSE_WARNING,
    EXPORTJOB_DELETE_DISABLE,

    EXPORTJOB_EDIT_CONTAINER_LOADED,
    EXPORTJOB_EDIT_CONTAINER_UNLOADED,
    EXPORTJOB_EDIT_FORM_LOADED,
    EXPORTJOB_EDIT_FORM_UNLOADED,
    EXPORTJOB_EDIT_DATA_LOAD,
    EXPORTJOB_EDIT_CONTAINER_SUBMIT,
    EXPORTJOB_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeExportJobs';

const defaultState = {
    refreshList: false,
    danger: false,
    exportjobid: 0,
    companyid: 0,
    userid: 0,
    exporttypeid: 0,
    name: '',
    description: '',
    filelocation: '',
    filename: '',
    statusid: 0,
    emailid: 0,
    email: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case EXPORTJOB_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                exportjobs: action.payload[0] ? action.payload[0].records : null,
                companies: action.payload[1] ? action.payload[1].companies : null,
                exporttypes: action.payload[2] ? action.payload[2].records : null,
            }
        case EXPORTJOB_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case EXPORTJOB_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case EXPORTJOB_SELECT_ROW:
            return {
                ...state,
                exportjobid: action.id
            }
        case EXPORTJOB_ADD:
            return {
                ...state
            }
        case EXPORTJOB_EDIT:
            return {
                ...state,
                exportjobid: action.id
            }
        case EXPORTJOB_DELETE:
            return {
                ...state,
                exportjobid: null
            }
        case EXPORTJOB_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case EXPORTJOB_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case EXPORTJOB_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case EXPORTJOB_EDIT_CONTAINER_LOADED:
        case EXPORTJOB_EDIT_DATA_LOAD:
            return {
                ...state,
                exportjobid: action.payload[0] ? action.payload[0].exportjobid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                userid: action.payload[0] ? action.payload[0].userid : 0,
                exporttypeid: action.payload[0] ? action.payload[0].exporttypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                filelocation: action.payload[0] ? action.payload[0].filelocation : '',
                filename: action.payload[0] ? action.payload[0].filename : '',
                statusid: action.payload[0] ? action.payload[0].statusid : 0,
                emailid: action.payload[0] ? action.payload[0].emailid : 0,
                email: action.payload[0] ? action.payload[0].email : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case EXPORTJOB_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case EXPORTJOB_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case EXPORTJOB_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case EXPORTJOB_LIST_CONTAINER_UNLOADED:
        case EXPORTJOB_LIST_TABLE_UNLOADED:
        case EXPORTJOB_EDIT_CONTAINER_UNLOADED:
        case EXPORTJOB_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerExportJobs.js